import { render, staticRenderFns } from "./MtsTakipHazirlaIslemDetayView.vue?vue&type=template&id=72ce8fd8&scoped=true"
import script from "./MtsTakipHazirlaIslemDetayView.vue?vue&type=script&lang=ts"
export * from "./MtsTakipHazirlaIslemDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ce8fd8",
  null
  
)

export default component.exports